import * as React from 'react';
import { AvatarInfo } from '@dndbeyond/character-rules-engine/es';
import CharacterAvatarPortrait from './CharacterAvatarPortrait';

interface Props {
    avatarInfo: AvatarInfo;
    className: string;
}
export default class CharacterAvatar extends React.PureComponent<Props, {}> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { avatarInfo, className } = this.props;

        const classNames: Array<string> = ['ddbc-character-avatar', className];
        if (avatarInfo.frameId) {
            classNames.push(`ddbc-character-avatar--${avatarInfo.frameId}`);
        }

        let frameStyles: React.CSSProperties = {};
        if (avatarInfo.frameUrl) {
            frameStyles = {
                backgroundImage: `url(${avatarInfo.frameUrl})`,
            };
        }

        return (
            <div className={classNames.join(' ')}>
                <CharacterAvatarPortrait avatarUrl={avatarInfo.avatarUrl} />
                {avatarInfo.frameId && <div className={'ddbc-character-avatar__frame'} style={frameStyles} />}
                {avatarInfo.frameId && (
                    <div className={'ddbc-character-avatar__frame-extra1'}>
                        <div className="ddbc-character-avatar__frame-extra-content ddbc-character-avatar__frame-extra1-content" />
                    </div>
                )}
                {avatarInfo.frameId && (
                    <div className={'ddbc-character-avatar__frame-extra2'}>
                        <div className="ddbc-character-avatar__frame-extra-content ddbc-character-avatar__frame-extra2-content" />
                    </div>
                )}
                {avatarInfo.frameId && (
                    <div className={'ddbc-character-avatar__frame-extra3'}>
                        <div className="ddbc-character-avatar__frame-extra-content ddbc-character-avatar__frame-extra3-content" />
                    </div>
                )}
            </div>
        );
    }
}
